/**
* @name: index
* @author: weiyong
* @date: 2024-07-27 11:29
* @description：index
* @update: 2024-07-27 11:29
*/
<template>
  <div class="wemail-avatar-wrap">
    <a-avatar :shape="showType"
              :style="{ backgroundColor: color, verticalAlign: 'middle' }"
              :size="size">
      <template #icon>
        <img class="w100b h100b" style="border-radius: 6px;" v-if="userLoadIcon||icon" :src="userLoadIcon||getImgIcon(icon)"/>
        <span style="font-size: 16px" v-else>{{ showLabelIcon }}</span>
      </template>
    </a-avatar>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "index",
});
</script>

<script lang="ts" setup>
import {Avatar as AAvatar} from 'ant-design-vue';
import {useUserImgAvatarHooks} from "@/components/userImgAvatar/hooks/useUserImgAvatarHooks";

interface propTypes {
  showType:'circle',
  userId:string;
  size:string;
  color:string;
  loadAvatar:boolean;
  icon:string;
  label:string;
  item: any;
}

const propsPage = withDefaults(defineProps<propTypes>(), {
  userId:'',
  size:'large',
  showType:'circle',
  loadAvatar:false,
  color:'#1890ff',
  icon:'',
  label:'',
  item: {},
});
const {item,label,loadAvatar,userId}=toRefs(propsPage);
const userLabel=ref('');

userLabel.value=unref(label)||unref(item).name;
const useImgSty = function () {
  return {};
}


/**
 * 显示名字标题
 */
const showLabelIcon = computed(() => {
  if (unref(userLabel) && (unref(userLabel)+'').length <= 2) {
    return userLabel
  }
  if((unref(userLabel)+'').length>2){
    return (unref(userLabel)+'').substring((unref(userLabel)+'').length - 2);
  }
});

const {
  userLoadIcon,
  getImgIcon,
}=useUserImgAvatarHooks({userLabel,loadAvatar,userId:(unref(item)&&unref(item).id)||unref(userId)});

</script>

<style type="text/css" lang="less">
.ant-avatar-lg.ant-avatar-icon{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
